<app-admin-back-button i18n="@@supervisor">Supervisor</app-admin-back-button>
<h3
  class="mt-5 mb-3"
  i18n="@@supervisor-functions"
>Supervisor-Funktionen</h3>
<div class="mb-4">
  <p-message i18n="@@supervisor-functions-description">
    Über individuelle Supervisor-Funktionen kannst du Schaltflächen mit Funktionen aus dem API-Bereich erstellen.
  </p-message>
</div>
<div class="row align-items-center g-3 mb-3">
  <div class="col-3">
    <span i18n="@@name">Name</span>
  </div>
  <div class="col">
    <input
      pInputText
      type="text"
      i18n-placeholder="@@name-supervisor-function"
      placeholder="Name der Supervisor-Funktion"
      [(ngModel)]="this.customFunctionName"
      fluid
    >
  </div>
</div>
<div class="row mt-3">
  <div class="col-3"></div>
  <div class="col-3">
    <p-button
      label="Hinzufügen"
      icon="ri-add-line"
      (onClick)="this.addCustomFunction()"
      i18n-label="@@add"
    >
    </p-button>
  </div>
</div>
@if (this.customFunction.length > 0) {
<p-table
  [value]="this.customFunction"
  [rowHover]="true"
  styleClass="p-datatable-sm"
>
  <ng-template pTemplate="header">
    <tr>
      <th i18n="@@name">Name</th>
      <th i18n="@@actions">Aktionen</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-custom
  >
    <tr>
      <td>
        <span
          class="fakelink"
          (click)="this.showDetailDrawer(custom.id)"
        >{{custom.name}}</span>
      </td>
      <td
        style="width: 2rem;"
        class="text-end"
      >
        <p-menu
          #menu
          appendTo="body"
          [model]="supervisorFunctionContextMenu"
          [popup]="true"
        ></p-menu>
        <p-button
          (onClick)="openSupervisorFunctionMenu($event, menu, custom, confirmTrigger)"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          [raised]="true"
          icon="ri ri-more-2-fill"
        ></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
}
<ng-template #confirmTrigger>
  <div class="modal-header">
    <span i18n="@@trigger-for-all-active-clients">An alle aktiven Clients senden</span>
    <p-button
      [text]="true"
      [rounded]="true"
      icon="pi pi-times"
      (onClick)="modalRef?.hide()"
      ariaLabel="Close"
    ></p-button>
  </div>
  <div class="modal-body">
    <span i18n="@@execTriggerForAllActiveClients">
      Bitte bestätige, dass die ausgewählte Funktion für alle aktiven Clients ausgeführt werden soll.
    </span>
  </div>
  <div class="modal-footer text-end">
    <p-button
      label="Ausführen"
      severity="danger"
      (onClick)="this.supervisorService.triggerSupervisorfunctionForAllActiveClients(this.selectedFunction, this.rss.botConfig._id); this.modalRef?.hide()"
      i18n-label="@@execute"
    ></p-button>
  </div>
</ng-template>

@if (detailDrawer) {
<p-drawer
  [(visible)]="this.detailDrawer"
  [position]="'right'"
  [modal]="true"
  [closeOnEscape]="true"
  styleClass="w-100 w-md-75 w-lg-50"
>
  @if (this.selectedFunctionId) {
  <app-supervisor-functions-details
    [selectedFunctionId]="this.selectedFunctionId"
    (closeDrawer)="this.detailDrawer = false"
  ></app-supervisor-functions-details>
  }
</p-drawer>
}